const config = {
                apiKey: "AIzaSyAnCA76k4FmqYKENYcIf9iezdjN9NPqEYg",
                authDomain: "rooftop-app-e7528.firebaseapp.com",
                databaseURL: "https://rooftop-app-e7528.firebaseio.com",
                projectId: "rooftop-app-e7528",
                storageBucket: "rooftop-app-e7528.appspot.com",
                messagingSenderId: "505225086031"
        };
